export default {
  notFoundTitle: 'Diese Seite konnten wir nicht finden',
  notFoundLead: 'Die gesuchte Adresse existiert nicht oder ist nicht mehr verfügbar.',
  notFoundCta: 'Zurück zur Startseite',

  legalBack: 'Zurück',

  // Impressum & Datenschutz: gesetzlich vorgegeben (Deutschland) – DE-Original bleibt erhalten.
};
